import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker";
import { DATE_FORMAT_DD_MM_YYYY } from "constants/DateConstant";
import { FormattedMessage } from "react-intl";

const PopulationByDateComponent = ({
  dateValue = "",
  onDateChange,
  minDate,
  maxDate,
}) => {
  var maxDate = new Date();
  maxDate.setDate(maxDate.getDate() - 1);
  return (
    <div className="population__info-form">
      <div className="row " style={{ width: "1000px" }}>
        <div className="col-12 col-lg-2 align-self-center">
          <label>
            <FormattedMessage id="calendar" />
          </label>
        </div>
        <div className="col-12 col-lg-10">
          <CustomizedDatePicker
            containerClass="population-by-date-component"
            className={"population-date-picker position-relative"}
            dateFormat={DATE_FORMAT_DD_MM_YYYY}
            value={dateValue}
            onChange={onDateChange}
            minDate={minDate}
            maxDate={maxDate.toISOString()}
          />
        </div>
      </div>
    </div>
  );
};

export default PopulationByDateComponent;
